import script from "./PdEyebrow.vue?vue&type=script&setup=true&lang=js"
export * from "./PdEyebrow.vue?vue&type=script&setup=true&lang=js"

import "./PdEyebrow.vue?vue&type=style&index=0&id=1660c130&scoped=true&lang=css"

import exportComponent from "../../../paydeck-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1660c130"]])

export default __exports__